const setItemSavedStatus = (state, { payload: { id, productId, saved } }) => ({
  ...state,
  items: !id
    ? state.items.map(item =>
        item.id === productId ? { ...item, saved } : item
      )
    : state.items
});

export default setItemSavedStatus;
